var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"data-test-name":"loading","size":100,"width":7,"indeterminate":"","color":"blue-grey darken-2"}},[_c('span',{staticClass:"text-center"},[_vm._t("default",function(){return [_vm._v("Loading")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }